import { Typography } from '@material-ui/core'
import TenantIcon from '@material-ui/icons/Person'
import { useParams } from 'react-router-dom'

import { getTranslate } from '../../localization'
import useStyles from './styles/TenantAddHeader.styles'

const TenantAddHeader = () => {
  const classes = useStyles()
  const { tenantId } = useParams<{ tenantId: string }>()

  return (
    <div className={classes.header}>
      <TenantIcon fontSize="large" />
      <Typography className={classes.title} variant="h3" gutterBottom>
        {getTranslate(tenantId ? 'Edit Tenant' : 'Add New Tenant')}
      </Typography>
    </div>
  )
}
export default TenantAddHeader
